module.exports = __webpack_public_path__ + "img/logo.69d587e3.png";